"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventPlaceStruct = void 0;
const superstruct_1 = require("superstruct");
const types_1 = require("../types");
const replaceTimestamps_1 = require("./replaceTimestamps");
exports.EventPlaceStruct = (0, superstruct_1.type)((0, replaceTimestamps_1.replaceTimestamps)(types_1.PlaceStruct.schema));
//# sourceMappingURL=EventPlace.js.map